import get from 'lodash/get';

import { filterCurrencyString } from '@/services/forms';

const crimeDeductiblesMap: Record<string, string[]> = {
	'03314d1d-af0a-4b7a-8260-e8051c426dcd': [ // Employee Theft
		'C2397.scEmployeeTheft.deductible'
	],
	'd62184f5-4d18-453f-993e-20f982adb26f': [ // Forgery or Alteration
		'C2397.scForgery.deductible'
	],
	'431c4619-8442-4f8c-806f-33eb31150e9c': [ // Inside the Premises - Theft of Money and Securities
		'C2397.scMoneyTheft.deductible'
	],
	'112e2b22-dba6-4cc2-af11-7203dd03a174': [ // Inside the Premises - Robbery or Safe Burglary of Other Property
		'C2397.scRobbery.deductible'
	],
	'ab3679d7-0b86-4e2b-8087-1d4fa70dd827': [ // Outside the Premises
		'C2397.scOutsidePremises.deductible'
	],
	'455b85ff-da84-4b5c-850a-6aa6f87e8011': [ // Inside the Premises - Theft of Other Property
		'C2397.scTheftOtherProperty.deductible'
	],
	'87fb4f07-c5b6-4660-84fa-5dfe997679b8': [ // Inside the Premises - Robbery of a Watchperson or Burglary of Other Property
		'C2397.scRobberyBurglaryOfOtherProperty.deductible'
	],
	'4e2ce03e-6e68-4a26-976f-b0ca8e7a7eba': [ // Inside the Premises - Robbery of a Custodian or Safe Burglary of Money and Securities
		'C2397.scRobberyBurglaryOfMoneyAndSecurities.deductible'
	],
	'dbbe4455-2a42-48b0-ab6c-f56d720aae4f': [], // Guests' Property
	'3b92c399-78f3-4434-8f59-00ddcc6a1d0a': [ // Fraudulent Impersonation
		'C2397.scFraudulentImpersonationOfEmployees.deductible',
		'C2397.scFraudulentImpersonationOfCustomersAndVendors.deductible'
	],
	'a489d849-bfad-4f35-9fa1-a8892bf8bf37': [], // Loss Payable
	'9c0d7766-f232-424f-ae77-f9f331198c4d': [ // Computer and Funds Transfer Fraud
		'C2397.scComputerFraud.deductible'
	],
	'd8aa19b2-1519-469f-aa2d-e5d6ed45cd64': [ // Money Orders and Counterfeit Money
		'C2397.scMoneyOrders.deductible'
	],
	'60060c31-62d2-4674-b791-3b5bc4aa4132': [ // Clients' Property
		'C2397.scClientProperty.deductible'
	],
	'abb44361-6e03-4cf0-acc8-a55331165411': [ // Identify Fraud Expense
		'C2397.scIdentityFraudExpense.deductible'
	]
};

export function getCommercialCrimeChanges( formGuid: string, formData: any ) {
	return ( formData?.subcoverages || [] ).flatMap( ( subForm: any, subcoverageIndex: number ) => {
		const deductibles = crimeDeductiblesMap[ subForm.formGuid as string ];

		return deductibles?.map( deductible => {
			const value = get( subForm, deductible, null );

			if ( value && Number( filterCurrencyString( value.value ) ) < 500 ) {
				return {
					parentForm: 'Commercial Crime (C-2397)',
					formName: subForm.formName,
					formGuid: formGuid,
					systemLabel: 'Deductible',
					systemId: deductible,
					fullPath: `subcoverages[${ subcoverageIndex }].${ deductible }`,
					subformPaths: [ `subcoverages[${ subcoverageIndex }]` ],
					oldValue: value.label,
					newValueDisplay: '$1,000',
					newValue: '1000'
				};
			}
		});
	}).filter( ( a: any ) => a );
}
